import React from 'react'
// import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import DashboardIcon from 'components/atoms/DashboardIcon'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontWeight: theme,
    marginLeft: theme.spacing(4),
  },
})

class DashboardTitle extends React.PureComponent {
  render() {
    const { classes, data } = this.props

    return data ? (
      <div className={classes.root}>
        <DashboardIcon large data={data.imageUrl} />
        <Typography className={classes.title} variant="h1">
          {data.name}
        </Typography>
      </div>
    ) : null
  }
}

DashboardTitle.propTypes = {
  data: PropTypes.object,
  items: PropTypes.array,
  classes: PropTypes.object,
}

export default withStyles(styles)(DashboardTitle)



// WEBPACK FOOTER //
// ./src/components/molecules/DashboardTitle.js